import { render, staticRenderFns } from "./header_promotion_name.vue?vue&type=template&id=71f03a86&scoped=true&"
import script from "./header_promotion_name.vue?vue&type=script&lang=js&"
export * from "./header_promotion_name.vue?vue&type=script&lang=js&"
import style0 from "./header_promotion_name.vue?vue&type=style&index=0&id=71f03a86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f03a86",
  null
  
)

export default component.exports